import axios from 'axios';

export default {
  get(url, succ, err) {
    axios.get(url)
    .then((response) => {
      succ(response);
    })
    .catch((response) => {
      err(response);
    });
  },
  delete(url, succ, err) {
    axios.delete(url)
    .then((response) => {
      succ(response);
    })
    .catch((response) => {
      err(response);
    });
  },
  put(url, obj, succ, err) {
    axios.put(url, obj)
    .then((response) => {
      succ(response);
    })
    .catch((response) => {
      err(response);
    });
  },
  patch(url, obj, succ, err) {
    axios.patch(url, obj)
    .then((response) => {
      succ(response);
    })
    .catch((response) => {
      err(response);
    });
  },
  post(url, obj, succ, err) {
    axios.post(url, obj)
    .then((response) => {
      succ(response);
    })
    .catch((response) => {
      err(response);
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js